export default {
    props: [{
        attr:  'lessonName',
        name: '课时名称'
    }, {
        attr: 'status',
        name: '课时状态',
        slot: 'status'
    }, {
        attr: 'sequence',
        name: '课时序列'
    }, {
        attr: 'startTime',
        name: '开始时间',
        slot: 'startTime'
    }, {
        attr: 'lessonType',
        name: '课时类型',
        slot: 'lessonType'
    }]
}